import './styles/tokens.css';
import './styles/base.css';
import './common.css';
import { html, render } from 'lit';
import { getAppTitle } from './config/environment';
import { initSentry } from './sentry';
import './ui/root';

initSentry();

document.title = getAppTitle();

const container = document.querySelector<HTMLDivElement>('#app');
if (container) {
  render(html`<sb-root></sb-root>`, container);
}
